import styled from "styled-components";
import useString2Unicode from 'hooks/useString2Unicode';

const AttrTextStyled = styled.div`
    &:before {
        content: "${props => props.text ? props.text : ''}";
    }
`;

export const AttrText = ({ className, text, children }) => {
    const string2unicode = useString2Unicode();
    return (
        <AttrTextStyled className={className} text={string2unicode(text)}>{children}</AttrTextStyled>
    )
}